//@import dependencies
import React, {CSSProperties, useState, useEffect} from 'react'
import { useTranslation } from 'react-i18next'
import {Modal} from 'react-bootstrap'
//@end

//@import components
import { IReferences } from 'app_types/admin/landings/landingTypes'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import InputComponent from 'app_components/commons/Input/InputComponent';
import InputFileComponent from 'app_components/commons/InputFileComponent/InputFileComponent';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService';
import { ScreenNotificationsUtil } from 'app_utils/screenNotification';
// @end

// @INFO Import Styles
import './../modalReferenceFormModule.scss'
import SwitchComponent from 'app_components/commons/switch'

// @ADD Component types
interface IModalReferenceFormModuleLayoutProps {
  open: boolean
  source: string
  editData?: IReferences
  className?: string
  style?: CSSProperties
  id?: string
  onClose?: (status?: boolean) => any
}

interface IFormData{
  title: string
  attached: any
  description: string
  qualification: string
  unique: string
  client?: string
  active: boolean
}

const uuid = require('react-uuid')

const ModalReferenceFormModuleLayout: React.FC<IModalReferenceFormModuleLayoutProps> = (props) => {

  const { t } = useTranslation()

  const [loading, updateLoading] = useState<boolean>(false)
  const [formData, updateFormData] = useState<IFormData>({
    title: '',
    attached: undefined,
    description: '',
    qualification: '0',
    unique: uuid(),
    active: true
  })

  // @INFO Servicios
  const landingService = new LandingService()
  const screenNotifications = new ScreenNotificationsUtil()

  useEffect(() => {
    if(props.editData){
      updateFormData({
        title: props.editData.title,
        description: props.editData.description,
        attached: props.editData.url,
        unique: props.editData.unique,
        qualification: props.editData.qualification || '',
        client: props.editData?.client && props.editData?.client !== "undefined" ? props.editData?.client : '',
        active: props.editData?.active !== undefined ? props.editData?.active : true
      })
    }
  },[props.editData])

  useEffect(() => {
    updateFormData({
      title: props.editData?.title || '',
      description: props.editData?.description || '',
      attached: props.editData?.url || undefined,
      unique: props.editData?.unique || uuid(),
      qualification: props.editData?.qualification || '',
      client: props.editData?.client && props.editData?.client !== "undefined" ? props.editData?.client : '',
      active: props.editData?.active !== undefined ? props.editData?.active : true
    })
  },[props.open])

  const handleCloseModal = (status?: boolean) => {
    if(props.onClose){
      props.onClose(status)
    }
  }

  const handleClickSave = async () => {
    updateLoading(true)
    let _formData = {...formData}
    const landingResponse = await landingService.saveReference(
      {..._formData, slug: props.source},
    )

    if (landingResponse) {
      let screen_notification_label = 'components.screen_notifications.update'

      screenNotifications.fireToast(
        {
          message: `${t(screen_notification_label)}`,
        },
        {
          position: 'top',
        }
      )
      handleCloseModal(true)
    }
    updateLoading(false)
  }
  return(
    <Modal
      show={props.open}
      onHide={() => handleCloseModal()}
    >
      <div
        className={`modal_reference_form_landing-layout ${props.className ? props.className : ''}`}
        style={props.style}
        id={props.id}
      >
        <TextComponent
          type='subtitle'
        >
          {props.editData ? `Editar referencia` : `Nuevo referencia`}
        </TextComponent>
        <SwitchComponent
          label='Activo'
          checked={formData.active}
          onClick={() => updateFormData({...formData, active: formData.active ? false : true})}
        />
        <InputComponent
          name='title'
          placeholder='Título'
          label='Título'
          onChange={(e) => updateFormData({...formData, title: e.target.value})}
          value={formData.title}
        />
        <InputComponent
          name='description'
          placeholder='Reseña'
          label='Reseña'
          invalidText='Máximo 200 caracteres'
          invalid={formData.description?.length>200 ? true : false}
          onChange={(e) => updateFormData({...formData, description: e.target.value})}
          value={formData.description}
        />
        <InputComponent
          name='client'
          placeholder='Nombre del cliente'
          label='Nombre del cliente'
          onChange={(e) => updateFormData({...formData, client: e.target.value})}
          value={formData.client}
        />
        <InputComponent
          name='qualification'
          type='number'
          min='1'
          max='5'
          placeholder='Calificación'
          label='Calificación'
          onChange={(e) => updateFormData({...formData, qualification: e.target.value})}
          value={formData.qualification}
        />
        <InputFileComponent
          as='image'
          name='attached'
          label='Imagen'
          onChange={(e) => updateFormData({...formData, attached: e.target.files})}
          value={formData.attached}
        />
        <div className="container-buttons-modal">
          <ButtonComponent
            onClick={() => handleCloseModal()}
          >
            Cancelar
          </ButtonComponent>
          <ButtonComponent
            variant='primary'
            onClick={() => handleClickSave()}
            loading={loading}
            disabled={formData.description?.length>200 ? true : false}
          >
            Guardar
          </ButtonComponent>
        </div>
      </div>
    </Modal>
  )
}

export default ModalReferenceFormModuleLayout
